import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const submitRSVP = (data) => api.post("/rsvp", data).then((r) => r.data);
export const fetchRSVPStats = () => api.get("/rsvp/stats").then((r) => r.data);
export const submitGuestbook = (data) => api.post("/guestbook", data).then((r) => r.data);
export const fetchGuestbook = () => api.get("/guestbook").then((r) => r.data);
